/* Farbschema-Manager — wählbares Schema (Ebene 1 Status + Ebene 2 cat-Palette).
   Mirror zu theme.js, kombinierbar mit data-theme (Hell/Dunkel/System).
   Setzt das resolved Schema via [data-scheme] auf <html>.

   Persistenz: localStorage (sofort, flicker-frei beim Boot in main.jsx) PLUS
   serverseitig pro User (user_settings.color_scheme) — damit die Wahl auch in
   der iOS-App / auf anderen Geräten greift. Der Server-Sync passiert in App.jsx
   nach dem Login; gespeichert wird in Settings via api.saveUserSettings. */

const KEY = 'urs-color-scheme';

export const SCHEMES = [
  {
    id: 'standard',
    label: 'Standard',
    description: 'Heutiges Erscheinungsbild.',
    swatches: ['#dc2626', '#ea580c', '#ca8a04', '#16a34a', '#0d9488', '#7c3aed', '#db2777', '#57534e'],
  },
  {
    id: 'gedaempft',
    label: 'Gedämpft',
    description: 'Weichere, weniger gesättigte Töne — ruhiger Arbeitslook.',
    swatches: ['#c26b6b', '#cf8a5a', '#c2a85a', '#6f9e78', '#5a9b94', '#8f7bb0', '#b97398', '#7d756e'],
  },
  {
    id: 'kontrast',
    label: 'Hoher Kontrast',
    description: 'Kräftig und gut unterscheidbar — barrierearm.',
    swatches: ['#dc2626', '#ea580c', '#d97706', '#16a34a', '#0d9488', '#7c3aed', '#db2777', '#475569'],
  },
  {
    id: 'erdig',
    label: 'Erdig',
    description: 'Warme Architekten-Palette.',
    swatches: ['#78716c', '#a8a29e', '#ca8a04', '#b45309', '#65a30d', '#4d7c0f', '#a16207', '#44403c'],
  },
];

const VALID = new Set(SCHEMES.map(s => s.id));

export function getScheme() {
  try {
    const v = localStorage.getItem(KEY);
    if (v && VALID.has(v)) return v;
  } catch {}
  return 'standard';
}

export function applyScheme(scheme = getScheme()) {
  const resolved = VALID.has(scheme) ? scheme : 'standard';
  document.documentElement.setAttribute('data-scheme', resolved);
}

export function setScheme(scheme) {
  const resolved = VALID.has(scheme) ? scheme : 'standard';
  try { localStorage.setItem(KEY, resolved); } catch {}
  applyScheme(resolved);
}

// Liefert die cat-Palette (Ebene 2) des AKTIVEN Schemas als aufgelöste Hex-Werte,
// direkt aus den CSS-Tokens (--cat-1..10) — eine Quelle der Wahrheit. Dient dem
// Projekt-/Akzent-Farbwähler, damit die Auswahl dem gewählten Schema folgt.
export function getSchemeCatColors() {
  if (typeof window === 'undefined') return [];
  const cs = getComputedStyle(document.documentElement);
  const out = [];
  for (let i = 1; i <= 10; i++) {
    const v = cs.getPropertyValue(`--cat-${i}`).trim();
    if (v) out.push(v);
  }
  return out;
}
